var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"formList"},[_c('div',{staticClass:"hd"},[_vm._v(_vm._s(_vm.label))]),_vm._t("contslot")],2)}
var staticRenderFns = []

export { render, staticRenderFns }